import React, { FC } from 'react'
import { Modal } from '@wmgtech/legato'
import { IsaakLinkForm } from '..'

import { IsaakLinkFormModalProps } from './IsaakLinkFormModal.props'

const IsaakLinkFormModal: FC<IsaakLinkFormModalProps> = ({ isModalOpen, setIsModalOpen, isaacLinkList, handleIsaacLinkSave }) => (
  <Modal
    className="create-project-modal"
    title="Local ISAAC"
    onClose={() => setIsModalOpen(false)}
    isOpen={isModalOpen}
  >
    <IsaakLinkForm onCancel={() => setIsModalOpen(false)} onSubmit={handleIsaacLinkSave} isaacLinkList={isaacLinkList} />
  </Modal>
)

export default IsaakLinkFormModal
